import React from 'react';
import i18next from 'i18next';
import classNames from 'classnames';

class ChatMessage extends React.PureComponent {
  render() {
    const { isMine, onReply, renderReply } = this.props;
    const { username, id, addedAt } = this.props.message;
    let { message } = this.props.message;

    const messageClasses = classNames(
      'chat-message',
      'magictime',
      'swashIn',
      isMine ? 'chat-message--mine' : ''
    );

    message = message.replace(/^(@[\w\d]+),\s*/i, '<b>$1</b>, ');

    return (
      <div className={messageClasses}>
        <div className="chat-message__author">
          <b>{username}</b>
        </div>
        <div className="chat-message__inner">
          <div
            className="chat-message__message"
            dangerouslySetInnerHTML={{ __html: message }}
          />
          <span className="chat-message__time">{addedAt ? addedAt : ''} </span>
        </div>
        {renderReply && (
          <span
            className="chat-message__reply"
            onClick={onReply.bind(this, username)}
          >
            {i18next.t('chat.reply')}
          </span>
        )}
      </div>
    );
  }
}

export default ChatMessage;



// WEBPACK FOOTER //
// ./app/components/Chat/ChatMessage/ChatMessage.jsx